export class CandidateSkillTag {
  id?: string;
  label: string;

  constructor(json: any = {}) {
    this.id = json.id || json._id;
    this.label = json.label || json.name || json;
  }
}

export class CandidateProfile {
  accountId: string;
  auraId?: string;
  email?: string;
  fullName: string;
  headline?: string;
  id: string;
  location?: string;
  profileImageUrl?: string;
  skills: CandidateSkillTag[];
  matchReason?: string;
  fitScore?: number;

  constructor(json: any = {}) {
    this.id = json.id || json._id || json.candidateProfileId || '';
    this.accountId = json.accountId;
    const firstName = json.firstName || json.account?.firstName;
    const lastName = json.lastName || json.account?.lastName;
    this.fullName = json.fullName || [firstName, lastName].filter(Boolean).join(' ') || json.name || 'Candidate';
    this.headline = json.headline || json.title || json.role || json.bio;
    this.email = json.email || json.contactEmail || json.account?.email;
    this.location = json.location || json.currentLocation;
    this.auraId = json.auraId || json.aura?.id;
    this.profileImageUrl =
      json.profileImageUrl || json.profilePictureUrl || json.profileImage?.url || json.account?.profilePictureResource?.url || '';
    this.skills = Array.isArray(json.skills) ? json.skills.map((skill: any) => new CandidateSkillTag(skill)) : [];
    this.matchReason = typeof json.matchReason === 'string' ? json.matchReason : undefined;
    this.fitScore = typeof json.fitScore === 'number' ? json.fitScore : undefined;
  }
}

export class SavedCandidateTag {
  id?: string;
  name: string;

  constructor(json: any = {}) {
    this.id = json.id || json._id;
    this.name = json.name || json.label || json;
  }
}

export class SavedCandidate {
  candidateProfile: CandidateProfile;
  createdAt?: Date;
  id: string;
  note?: string;
  tags: SavedCandidateTag[];
  updatedAt?: Date;

  constructor(json: any = {}) {
    this.id = json.id || json._id || '';
    this.candidateProfile = new CandidateProfile(json.candidateProfile || json);
    this.note = json.note;
    this.tags = Array.isArray(json.tags) ? json.tags.map((tag: any) => new SavedCandidateTag(tag)) : [];
    this.createdAt = json.createdAt ? new Date(json.createdAt) : undefined;
    this.updatedAt = json.updatedAt ? new Date(json.updatedAt) : undefined;
  }
}
